<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 30 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
        添加提存兌換
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div class="content" id="duihuanid">
        <div class="content_div">
          <!-- 1 -->
          <div style="display: flex;">
            <div class="content_div_name">
              <div style="flex-shrink: 0;">交易類型：</div>
              <a-select v-model="jylx" placeholder="請選擇交易類型" style="width: 100%;" @change='jyClcik(jylx)'>
                <a-select-option value="0">存款</a-select-option>
                <a-select-option value="1">提款</a-select-option>
                <a-select-option value="3">貨幣兌換</a-select-option>
              </a-select>
            </div>
            <div style="width: 10%;"></div>
            <div class="content_div_name">
              <div style="flex-shrink: 0;">證券帳號：</div>
              <div style="width: 100%;position: relative;">
                <Situationall v-model="zqzh"
                  :class="arrList.obj1?'border_cla1':''"
                  :url='$api.getSecurityAccount'
                  :route1="zqzhFlag"
                  @child="secrchClick(1)"
                  :style='"width: 100%;"'
                  >
                </Situationall>
                <!-- <a-input v-model="zqzh" onkeyup="value=value.replace(/[^\d]/g,'')" :maxLength="7" placeholder="請輸入證券帳號"/> -->
                <a-icon v-if="jylx!=3" style="position: absolute; right: 0.5rem;top: 0.5rem;cursor: pointer;z-index: 99;"  @click="secrchClick()" type="search"/>
              </div>
            </div>
          </div>
          <!-- 2 存款金額： -->
          <div style="display: flex;margin-top: 1.5rem;">
            <div class="content_div_name">
              <div style="flex-shrink: 0;">{{jylx == 0 ?'存款金額：': jylx == 1 ? '提款金額：'  :'賣出金額：'}}</div>
              <!-- 货币兑换 -->
              <div class="content_div_name" v-if="jylx == 3">
                <a-select v-model="ckje_sele1" placeholder="請選擇" @change="mcClick(1)" style="width: 37%;flex-shrink: 0;" >
                  <a-select-option v-for="(item,index) in currencyList1" :disabled="mrje_sele == 'HKD' && item.name == 'HKD'" :key="index" :value="item.key">{{item.name}}</a-select-option>
                </a-select>
                <div style="width: 5%;"></div>
                <a-input v-model="ckje_inp1" :class="arrList.obj6 ? 'border_cla':''" :disabled="!ckje_sele1" onkeyup="" @focus="focusClick(1)" @blur="blurClick(ckje_inp1,1)" @change="moneyClick(1)" :placeholder="jylx == 0 ?'請輸入存款金額': jylx == 1 ? '請輸入提款金額'  :'請輸入賣出金額'"/>
              </div>
              <!-- 提存兑换 -->
              <div class="content_div_name" v-else>
                <a-select v-model="ckje_sele" placeholder="請選擇" style="width: 37%;flex-shrink: 0;" >
                  <a-select-option v-for="(item,index) in currencyList" :key="index" :value="item.key">{{item.name}}</a-select-option>
                </a-select>
                <div style="width: 5%;"></div>
                <a-input v-model="ckje_inp" :class="arrList.obj2 ? 'border_cla':''" :disabled="!ckje_sele" @focus="focusClick(3)"  @blur="blurClick(ckje_inp,3)" @change="moneyClick(3)"  onkeyup="" :placeholder="jylx == 0 ?'請輸入存款金額': jylx == 1 ? '請輸入提款金額'  :'請輸入賣出金額'"/>
              </div>
            </div>
            <div style="width: 10%;"></div>
            <div class="content_div_name" v-if="jylx == 1 || jylx == 0">
              <div style="flex-shrink: 0;">銀行名稱：</div>
              <a-input v-model="yhmc" :class="arrList.obj3 ? 'border_cla':''" @input="arrList.obj3 = false" placeholder="請輸入銀行名稱"/>
            </div>
            <div class="content_div_name" v-else>
              <div style="flex-shrink: 0;">買入金額：</div>
              <div class="content_div_name">
                <a-select v-model="mrje_sele" placeholder="請選擇" :disabled="!ckje_sele1"  @change="mcClick(2)"  style="width: 37%;flex-shrink: 0;">
                  <a-select-option v-for="(item,index) in currencyList1" :key="index" :disabled="ckje_sele1 == 'HKD' && item.name == 'HKD'" :value="item.key">{{item.name}}</a-select-option>
                </a-select>
                <div style="width: 5%;"></div>
                <a-input v-model="mrje_inp" :class="arrList.obj7 ? 'border_cla':''" :disabled="!mrje_sele" onkeyup=""  @focus="focusClick(2)"   @blur="blurClick(mrje_inp,2)"  @change="moneyClick(2)" placeholder="請輸入買入金額"/>
              </div>
            </div>
          </div>
          <!-- 3-1 -->
          <div style="display: flex;margin-top: 1.5rem;" v-if="jylx == 0 || jylx == 1">
            <div class="content_div_name">
              <div style="flex-shrink: 0;">銀行號碼：</div>
              <a-input v-model="yhhm" :class="arrList.obj4 ? 'border_cla':''" @input="arrList.obj4 = false" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="請輸入銀行號碼"/>
            </div>
            <div style="width: 10%;"></div>
            <div class="content_div_name">
              <div style="flex-shrink: 0;">備註信息：</div>
              <a-input v-model="bzxx" :class="arrList.obj5 ? 'border_cla':''" @input="arrList.obj5 = false"  placeholder="請輸入電話號碼"/>
            </div>
          </div>
          <!-- 3-2 -->
          <div style="display: flex;margin-top: 1.5rem;" v-else>
            <div class="content_div_name">
              <div style="flex-shrink: 0;">貨幣匯率：</div>
              <a-input v-model="hbhl" onkeyup="value=value.match(/\d+\.?\d{0,8}/,'')"  @blur="blurClick(hbhl,4)"  @change="hlClick()" placeholder="請輸入貨幣匯率"/>
            </div>
            <div style="width: 10%;"></div>
            <div class="content_div_name">
              <div style="flex-shrink: 0;">交易日期：</div>
              <a-date-picker :class="arrList.obj8 ? 'border_cla':''"  @change="arrList.obj8 = false" :disabled-date="disabledDate" v-model="jyrq" placeholder='請選擇交易日期' style="width: 100%;"/>
            </div>
          </div>
          <div style="display: flex;margin-top: 1.5rem;" >
            <div class="content_div_name">
              <div style="flex-shrink: 0;">提交日期：</div>
              <a-date-picker :class="arrList.obj9 ? 'border_cla':''"  :defaultValue="getCurrentData()"   @change="arrList.obj9 = false,dateFlag()"  v-model="tjrq" placeholder='請選擇提交日期' style="width: 100%;"/>
            </div>
            <div style="width: 10%;"></div>
            <div class="content_div_name">
            </div>
          </div>
          <div style="display: flex;align-items: center;margin-top: 1.5rem;" v-if="jylx == 3 && ckje_sele1 && mrje_sele && tishiText" class="convert_cla">
            <div>{{tishiText}}</div>
            <div style="margin-left: 1rem;">截止{{formattedTime}} 香港時間</div>
          </div>
        </div>
        <div class="content_btn">
          <div class="content_btn_div" @click="subClick()">提&emsp;交</div>
        </div>
      </div>
      <div style="width: 100%; height: 1px"></div>

    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
import moment from 'moment';
export default {
  computed: {
    formattedTime() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");

      return `${year}年${month}月${day}日 ${hours}:${minutes}`;
    }
  },
  data() {
    return {
      arrList:{
        obj1:false,
        obj2:false,
        obj3:false,
        obj4:false,
        obj5:false,
        obj6:false,
        obj7:false,
        obj8:false,
        obj9:false,
      },
      zqzhFlag:'zqzhSeach',
      ishand: false,
      visible: true,
      timeFlag: false,
      currencyList:[
        {
          key:'HKD',
          name:'HKD'
        },
        {
          key:'USD',
          name:'USD'
        },
        {
          key:'CNY',
          name:'CNY'
        },
        {
          key:'JPY',
          name:'JPY'
        },
        {
          key:'AUD',
          name:'AUD'
        },
        {
          key:'SGD',
          name:'SGD'
        },
        {
          key:'TWD',
          name:'TWD'
        },
        {
          key:'MYR',
          name:'MYR'
        },
      ],
      currencyList1:[
        {
          key:'HKD',
          name:'HKD'
        },
        {
          key:'USD',
          name:'USD'
        },
        {
          key:'CNY',
          name:'CNY'
        },
        {
          key:'JPY',
          name:'JPY'
        },
        {
          key:'AUD',
          name:'AUD'
        },
        {
          key:'SGD',
          name:'SGD'
        },
        {
          key:'TWD',
          name:'TWD'
        },
      ],
      jylx:"0",
      zqzh:'',
      ckje_sele:undefined,
      ckje_inp:'',
      ckje_sele1:undefined,
      ckje_inp1:'',
      mrje_sele:undefined,
      mrje_inp:'',
      yhmc:'',
      yhhm:'',
      bzxx:'',
      hbhl:'',
      jyrq:'',
      tjrq:'',
      tishiText:''
     
    };
  },
  mounted() {
    this.tjrq =  new Date().toLocaleDateString()
  },

  methods: {
    dateFlag(){
      this.timeFlag = true
    },
     getCurrentData(){
      return new Date().toLocaleDateString();
    },
    disabledDate(current){
      // 不可以选择之前的日期,今天包括之后可以选，控制大于小于来实现选择之前的日期还是之后的日期
      return current < moment().subtract(1, 'day');
    },
    getArea(area) {
        return String(area).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    secrchClick(val){
      if (val == 1) {
        this.arrList.obj1=false
        return
      }
      if (this.zqzh.length < 7 && val == 1 || !this.zqzh) {
        return
      }
      this.$ajax({
        method: 'post',
        url: this.$api.getBankCodeAndName,
        headers: {
          token: this.$store.state.token
        },
        data: {
          username:this.zqzh
        }
      }).then(res => {
        if (res.data.qmiscode === 1000) {
          this.yhhm = res.data.recipient_bankcode
          this.yhmc = res.data.recipient_bankname
          this.bzxx = res.data.mobile
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      })
    },
    handleCancel(ev) {
        this.$emit("child", 0);
    },
    jyClcik(val){
      this.ckje_sele1 = undefined
      this.ckje_inp1 = ''
      this.mrje_sele = undefined
      this.mrje_inp = ''
      this.hbhl = ''
      this.jyrq = ''
      this.zqzh = ''
      this.tjrq = this.getCurrentData()
       
    },
    subClick(){
      if (this.jylx == 3) {
        if (!this.zqzh) {
          this.arrList.obj1 = true
          return
        }
        if (!this.ckje_inp1) {
          this.arrList.obj6 = true
          return
        }
        if (!this.mrje_inp) {
          this.arrList.obj7 = true
          return
        }
        if (!this.jyrq) {
          this.arrList.obj8 = true
          return
        }
        if (!this.tjrq) {
          this.arrList.obj9 = true
          return
        }
      }else{
        if (!this.zqzh) {
          this.arrList.obj1 = true
          return
        }
        if (!this.ckje_inp) {
          this.arrList.obj2 = true
          return
        }
        if (!this.yhmc) {
          this.arrList.obj3 = true
          return
        }
        if (!this.yhhm) {
          this.arrList.obj4 = true
          return
        }
        if (!this.bzxx) {
          this.arrList.obj5 = true
          return
        }
        if (!this.tjrq) {
          this.arrList.obj9 = true
          return
        }
      }
      // var now = new Date();
      // // 获取当前的小时、分钟和秒
      // var hours = now.getHours();
      // var minutes = now.getMinutes();
      // var seconds = now.getSeconds();
      
      // console.log("当前时分秒：" + App.oDate.secsTime3(this.tjrq._d) + " " + hours + ":" + minutes + ":" + seconds);
      var createtime 
      // this.timeFlag ? this.tjrq: App.oDate.secsTime3(this.tjrq._d)
      if (this.timeFlag) {
        createtime = App.oDate.secsTime3(this.tjrq._d)
      }else{
        var formattedDateString = this.tjrq.replace(/\//g, '-');
        createtime = formattedDateString

      }
      this.$ajax({
        method: 'post',
        url: this.$api.addDepositExchange,
        headers: {
          token: this.$store.state.token
        },
        data: {
          type:this.jylx,
          username:this.zqzh,
          ccytype:this.ckje_sele,
          price:this.ckje_inp,
          ccy_s:this.ckje_sele1,
          price_s:this.ckje_inp1,
          ccy_b:this.mrje_sele,
          price_b:this.mrje_inp,
          recipient_bankname:this.yhmc,
          recipient_bankcode:this.yhhm,
          remark:this.bzxx,
          rate:this.hbhl,
          tradetime: App.oDate.secsTime3(this.jyrq._d),
          createtime: createtime,
        }
      }).then(res => {
        if (res.data.qmiscode === 1000) {

          this.$emit("child", 0);
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      })
    },
    hl(val,ind,ind2){
      console.log(val);
      this.$ajax({
        method: 'post',
        url: this.$api.getMoneytoHKDRate,
        headers: {
          token: this.$store.state.token
        },
        data: {
        }
      }).then(res => {
        if (res.data.qmiscode === 1000) {
          if (val == 'AUD') {
            this.hbhl = res.data.HKDRate.AUD
          }
          if (val == 'TWD') {
            this.hbhl = res.data.HKDRate.TWD
          }
          if (val == 'SGD') {
            this.hbhl = res.data.HKDRate.SGD
          }
          if (val == 'JPY') {
            this.hbhl = res.data.HKDRate.JPY
          }
          if (val == 'USD') {
            this.hbhl = res.data.HKDRate.USD
          }
          if (val == 'CNY') {
            this.hbhl = res.data.HKDRate.CNY
          }
          if (ind == 1) {
            this.hlClick(ind2)
          }
        
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      })
    },
    mcClick(val){
      /**
       * 
       * val == 1 :ckje_sele1
       * val == 2 :mrje_sele
       */
      if (val == 1) {
        if (this.mrje_sele!='HKD' && this.mrje_sele) {
          this.mrje_sele = 'HKD'
        }else{
          if (this.ckje_sele1!='HKD'){
            this.mrje_sele = 'HKD'
          }
        }
        this.hl(this.ckje_sele1,1,1)
        setTimeout(() => {
          if (this.ckje_inp1) {
            this.blurClick(this.ckje_inp1,val)
          }
          this.tishiText = "1 "+this.ckje_sele1 + ' 兌換 ' + this.hbhl + ' HKD'
        }, 500); // 设置延时时间为1秒（1000毫秒）
      }
      if (val == 2) {
        if (this.ckje_sele1!='HKD' && this.ckje_sele1) {
          this.ckje_sele1 = 'HKD'
        }else{
          if (this.mrje_sele!='HKD'){
            this.ckje_sele1 = 'HKD'
          }
        }
        
        this.hl(this.mrje_sele,1,2)
        setTimeout(() => {
          if (this.mrje_inp) {
            this.blurClick(this.mrje_inp,val)
          }
          this.tishiText = "1 "+this.mrje_sele + ' 兌換 ' + this.hbhl + ' HKD'
        }, 500); // 设置延时时间为1秒（1000毫秒）
      }
      
    },
    moneyClick(val){
      this.focusClick(val)

      if (val == 1) {
        this.arrList.obj6=false
        this.ckje_inp1=this.ckje_inp1.match(/\d+\.?\d{0,8}/,'')
      }
      if (val==2) {
        this.arrList.obj7=false
        this.mrje_inp=this.mrje_inp.match(/\d+\.?\d{0,8}/,'')
      }
      if (val==3) {
        this.arrList.obj2=false
        this.ckje_inp=this.ckje_inp.match(/\d+\.?\d{0,8}/,'')
      }

      // console.log(this.mrje_inp,this.ckje_inp1);
      if (val ==  1 && this.ckje_sele1 == 'HKD') {
        if (this.hbhl>0) {
          this.mrje_inp = (this.ckje_inp1/this.hbhl).toFixed(3)
        }
      }
      if (val ==  1 && this.ckje_sele1 != 'HKD') {
        if (this.hbhl>0) {
          this.mrje_inp = (this.ckje_inp1*this.hbhl).toFixed(3)
        }
      }
      if (val ==  2 && this.mrje_sele == 'HKD') {
        if (this.hbhl>0) {
          this.ckje_inp1 = (this.mrje_inp/this.hbhl).toFixed(3)
        }
      }
      if (val ==  2 && this.mrje_sele != 'HKD') {
        if (this.hbhl>0) {
          this.ckje_inp1 = (this.mrje_inp*this.hbhl).toFixed(3)
        }
      }
    },
    hlClick(val){
      console.log(this.hbhl);
      if (this.ckje_sele1 == 'HKD' && this.ckje_inp1) {
        this.moneyClick(1)
      }
      if (this.mrje_sele == 'HKD' && this.mrje_inp) {
        this.moneyClick(2)
      }
    },
    focusClick(val){
      console.log(val,"获取焦点");
      if (val == 1 || val == 2) {
        if (this.ckje_inp1) {
          this.ckje_inp1 = this.ckje_inp1.replace(/,/g, '');
        }
        if (this.mrje_inp) {
          this.mrje_inp = this.mrje_inp.replace(/,/g, '');
        }
      }
      // if (val == 2) {
      //   if (this.mrje_inp) {
      //     this.mrje_inp = this.mrje_inp.replace(/,/g, '');
      //   }
      // }
      if (val == 3) {
        if (this.ckje_inp) {
          this.ckje_inp = this.ckje_inp.replace(/,/g, '');
        }
      }
    },
    blurClick(val,ind){
      console.log(val,"失去焦点");
      if (ind == 1) {
        this.ckje_inp1 = this.getArea(Number(val).toFixed(2))
        if (Number.isInteger(this.mrje_inp)) {
          this.mrje_inp = this.getArea(Number(this.mrje_inp).toFixed(2))
        }else{
          this.mrje_inp = this.getArea(Number(this.mrje_inp).toFixed(3))
        }
      }
      
      if (ind == 2) {
        this.mrje_inp = this.getArea(Number(val).toFixed(2))
        if (Number.isInteger(this.ckje_inp1)) {
          this.ckje_inp1 = this.getArea(Number(this.ckje_inp1).toFixed(2))
        }else{
          this.ckje_inp1 = this.getArea(Number(this.ckje_inp1).toFixed(3))
        }
      }
      if (ind == 3) {
        this.ckje_inp = this.getArea(Number(val).toFixed(2))
      }
      if (ind == 4) {
        if (this.mrje_inp) {
          this.mrje_inp = this.getArea(Number(this.mrje_inp).toFixed(3))
        }
        if (this.ckje_inp1) {
          this.ckje_inp1 = this.getArea(Number(this.ckje_inp1).toFixed(3))
        }
      }
    }
    

  },
};
</script>

<style lang="scss">
  .border_cla {
    border-color: red !important;
  }
  .border_cla .ant-input{
    border-color: red !important;
  }
  .border_cla1{
    border: 1px solid red;
    border-radius: 4px;
  }
	@media screen and (min-width:2200px){
    .content{
      font-size: 20px !important;
    }
    .saveBtn {
      font-size: 20px !important;
    }
    .content_btn_div{
      font-size: 20px !important;
    }
    .ant-select-selection__rendered {
      height: 100%;
      font-size: 0.8rem !important;
    }
    .convert_cla{
      font-size: 18px !important;
    }

  }
  .convert_cla{
      font-size: 14px;
    }
.ant-select-dropdown-menu {
    max-height: 500px !important; 
  }
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 2.5rem 1rem 1.5rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
  font-size: 16px;
}
.content_div_name{
  display: flex;
  align-items: center;
  width: 100%;
}
.content_btn{
  margin-top: 1.5rem;
}
.content_btn_div{
  width: 25%;
  background: #0c8b97;
  padding: 10px 0;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  font-size: 16px;
  margin: auto;
  cursor: pointer;

}
</style>
